"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EMROAuthAuthenticateStatus", {
  enumerable: true,
  get: function () {
    return _mailruOnetapCallback.EMailRuOneTapCallbackStatus;
  }
});
exports.mrOAuthAuthenticate = mrOAuthAuthenticate;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _mailruOnetapCallback = require("../types/api-models/auth/mailru-onetap-callback");
const _excluded = ["subdomain"];
function mrOAuthAuthenticate(httpApi, parameters) {
  const {
      subdomain
    } = parameters,
    restParameters = (0, _objectWithoutProperties2.default)(parameters, _excluded);
  return httpApi.fetch((0, _mailruOnetapCallback.createMailRuOneTapCallbackModel)({
    parameters: restParameters
  }), {
    subdomain
  });
}